import { useContext, useEffect, useState } from 'react'
import Layout from '../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import layoutBgImg from '../Images/layout/others.jpg'
import { Context } from '../Store/context'
import Loading from '../Component/loader/loader'
import { GetCollectionDecisions } from '../api/Queries/get'
import GlobalLayout from '../Component/layout/global-layout'

const CollectionDecisions = () => {
    const [document, setDocument] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { t, i18n } = useTranslation();
    const { showError } = useContext(Context);

    useEffect(() => {
        setIsLoading(true)
        const getStateDuty = async () => {
            try {
                const data = await GetCollectionDecisions()
                setIsLoading(false)
                setDocument(data[0] || null);
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getStateDuty()
    }, [showError])

    const getDocument = (document) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return document.rus_pdf;
        } else if (currentLang === 'en') {
            return document.eng_pdf;
        }
        return document.tm_pdf;
    };

    const pdf = getDocument(document)

    return (
        <GlobalLayout
            title={`${t('collection_decisions')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Dowlet pajy, Döwlet pajy, Государственная пошлина"
        >
            <div className='mb-20'>
                <Layout
                    title={t('collection_decisions')}
                    layoutBgImg={layoutBgImg}
                />
                <main className='media'>
                    <div className='bg-white dark:bg-dark-box dark:text-dark-text 
                                mt-8 p-8 w-full'>
                        {isLoading ? <Loading /> :
                            <div className='h-[1000px] max-h-max'>
                                <iframe
                                    src={`${pdf}#toolbar=0&navpanes=0&view=FitH`}
                                    className="w-full h-full"
                                    frameBorder="0"
                                    title="PDF Viewer"
                                ></iframe>
                            </div>
                        }
                    </div>
                </main>
            </div>
        </GlobalLayout>
    )
}

export default CollectionDecisions